import { useEffect, useState } from 'react'
import useOrderFormParams from '@/modules/order/hooks/use-order-form-params.hook'
import { useOrderFormStore } from '@/modules/order/stores/order-form.store'
import type { TProducts } from '../types/product.type'

export const useProductStockLimit = (product: TProducts | undefined) => {
  const { limitaQuantidadePorEstoque: stockLimitEnabled, isViewOrder } = useOrderFormParams()
  const limitaQuantidadePorEstoque = stockLimitEnabled && !isViewOrder
  const stock = Number(product?.produto?.qtdEstoque)
  const availableQuantity = Number.isFinite(stock) ? Math.max(0, stock) : 0
  const validatePackage = useOrderFormStore(state => state.jsonOrderForm?.operacao?.flagValidaQtdEmbalagem)
  const packageQuantity = Number(product?.produto?.qtdeEmbalagem)
  const usePackageLimit = validatePackage && Number.isFinite(packageQuantity) && packageQuantity > 0
  const maximumQuantity = usePackageLimit
    ? Math.floor(availableQuantity / packageQuantity) * packageQuantity
    : availableQuantity
  const [showStockWarning, setShowStockWarning] = useState(false)

  const limitQuantityToStock = (quantity: number) => {
    if (!limitaQuantidadePorEstoque) return quantity

    if (quantity > maximumQuantity) {
      setShowStockWarning(true)
      return maximumQuantity
    }
    if (quantity < maximumQuantity) setShowStockWarning(false)
    return quantity
  }

  useEffect(() => {
    if (!limitaQuantidadePorEstoque || product?.quantidade < maximumQuantity) {
      setShowStockWarning(false)
    }
  }, [limitaQuantidadePorEstoque, product?.quantidade, maximumQuantity])

  useEffect(() => {
    setShowStockWarning(false)
  }, [product?.fkProduto])

  return {
    limitaQuantidadePorEstoque,
    maximumQuantity,
    limitQuantityToStock,
    stockWarning: limitaQuantidadePorEstoque && showStockWarning
      ? usePackageLimit
        ? `Quantidade ajustada ao máximo permitido pelo estoque e embalagem: ${maximumQuantity} un.`
        : `Quantidade ajustada ao estoque disponível: ${maximumQuantity} un.`
      : '',
  }
}
